module.exports = __webpack_public_path__ + "static/media/open_sinister_chest.6a28228e.png";